import React from "react";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "@redux-devtools/extension";
import { Provider } from "react-redux";
import { httpMiddleware } from "../middleware/index";

// error handling dependencies
import moment from "moment";
import * as sourceStackTrace from "sourcemapped-stacktrace";
import { API_URL } from "../constants";
const { detect } = require("detect-browser");
const browser = detect();
const browserName = browser.name;
const browserVersion = browser.version;

const createProvider = (reducer, thunk) => {
  const middleware = composeWithDevTools(
    applyMiddleware(httpMiddleware, thunk)
  );
  // const middleware = applyMiddleware(httpMiddleware, thunk);

  // error handling with redux provider
  class AppProvider extends React.Component {
    _ismounted = false;
    constructor(props) {
      super(props);
      this.showError = this.showError.bind(this);
      this.state = {
        error: null,
      };

      const errCatchingReducer = (state, action) => {
        try {
          return reducer(state, action);
        } catch (error) {
          // send logs to server
          const minifiedStack = error.stack;
          sourceStackTrace.mapStackTrace(minifiedStack, (stackTrace) => {
            let srcIndex = stackTrace.findIndex((d) => d.includes("src"));
            let errorLine = stackTrace[srcIndex];
            let errorLine2 = stackTrace[srcIndex + 1];
            let componentIndex = errorLine.indexOf("src");
            let component = errorLine.slice(
              componentIndex,
              errorLine.length - 1
            );
            let originFunction = errorLine2.substring(
              errorLine2.indexOf("at") + 3,
              errorLine2.indexOf("(") - 1
            );
            let obj = {
              error: error.message,
              component: component,
              originFunction: originFunction,
              dateTime: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
            };
            let errors = [];
            errors.push(obj);
            this.showError(errors);
          });
          return state;
        }
      };

      this.store = createStore(errCatchingReducer, middleware);
    }

    static getDerivedStateFromError() {
      // Update state so the next render will show the fallback UI.
      return { error: true };
    }

    componentDidMount() {
      this._ismounted = true;
    }

    componentWillUnmount() {
      this._ismounted = false;
    }

    componentDidCatch(error) {
      console.error(error);
      const minifiedStack = error.stack;
      sourceStackTrace.mapStackTrace(minifiedStack, (stackTrace) => {
        let srcIndex = stackTrace.findIndex((d) => d.includes("src"));
        let errorLine = stackTrace[srcIndex];
        let errorLine2 = stackTrace[srcIndex + 1];
        let componentIndex = errorLine.indexOf("src");
        let component = errorLine.slice(componentIndex, errorLine.length - 1);
        let originFunction = errorLine2.substring(
          errorLine2.indexOf("at") + 3,
          errorLine2.indexOf("(") - 1
        );
        let obj = {
          error: error.message,
          component: component,
          originFunction: originFunction,
          dateTime: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
        };
        let errors = [];
        errors.push(obj);
        // this.props.sendErrorLogs(errors);
        this.showError(errors);
      });
    }

    showError(error) {
      if (this._ismounted) {
        this.setState({ error });
      } else {
        this.state = { error };
      }
      console.log(error);

      // send logs to server
      const account = JSON.parse(localStorage.getItem("DefaultAC"));
      const user = JSON.parse(localStorage.getItem("user"));
      const userTS = JSON.parse(localStorage.getItem("TS"));
      const platform = localStorage.getItem("platform");
      const location = localStorage.getItem("location");
      const data = {
        UserDetails: {
          SID: userTS.SID,
          AccountCode: account.AC,
          AccountDesc: account.AD,
          UDES: userTS.UDES,
          UID: userTS.UID,
          Platform: platform,
          Browser: browserName,
          BrowserVersion: browserVersion,
        },
        errDetails: error,
      };
      fetch(`${API_URL}/user/errorLog`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Cache-Control": "no-cache",
          sid: user.sid,
          username: user.id,
          location: location,
          platform: platform,
          "x-auth": user.authToken,
        },
        body: JSON.stringify(data),
      });
    }

    render() {
      // show fallback UI for errors
      if (this.state.error) {
        return (
          <div className="fallbackUI">
            <p>
              Encountered server error. Click <a href="/login">here</a> to
              relogin again.
            </p>
          </div>
        );
      }
      // return the provider
      return <Provider {...this.props} store={this.store} />;
    }
  }

  return AppProvider;
};
export default createProvider;
